/* Así funciona · Horno 3 en 1 con Cafetera y Plancha (2126960)
   Base: la foto real del fabricante (HD) con el horno APAGADO (mismos píxeles: resistencias sin brillo, pan sin
   tostar, jarra vacía, luces sin prender). La clienta gira la perilla REAL del temporizador y la de temperatura: se
   prende la luz Power real, las resistencias se encienden (la cavidad real encendida aparece según el calor), el
   pan real se va tostando y la perilla vuelve sola a cero; en la plancha sube un vapor suave. Con el switch rojo de
   la cafetera, el café real llena la jarra de abajo hacia arriba. Ficha: horno tostador con perillas, plancha arriba,
   cafetera con jarra de vidrio (piezas en tiendas/nayhogar/funciona/horno-3-en-1-con-cafetera-y-plancha-cuchillos). */
NHF.escena('horno-3-en-1-con-cafetera-y-plancha-cuchillos', function (E) {
  const D = /*DATOS*/{"w":1216,"h":1216,"base":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-apagado.webp","calor":{"src":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-calor.webp","caja":[122,355,394,443]},"pan":{"src":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-pan.webp","caja":[134,370,373,398]},"switch":{"src":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-switch.webp","caja":[527,546,39,39],"centro":[546.84375,565.84375]},"power":{"src":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-power.webp","caja":[545,808,26,30],"centro":[556.4625,821.86875]},"cafe":{"src":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-cafe.webp","caja":[682,732,235,169],"sup":{"cx":801,"cy":778,"rx":106,"ry":36,"ang":13},"fondo":880},"perilla_temp":{"src":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-perilla-temp.webp","caja":[518,603,70,87],"centro":[552.5,645.9],"rx":32.1,"ry":40.4},"perilla_tiempo":{"src":"fn-horno-3-en-1-con-cafetera-y-plancha-cuchillos-perilla-tiempo.webp","caja":[519,708,70,87],"centro":[553.9,751.0],"rx":32.1,"ry":40.4},"vapor_plancha":[421.5625,308.75,142.5,47.5],"vapor_cafe":[783.75,391.875,142.5,35.625]}/*FIN*/;
  const W = D.w, Hh = D.h;
  const S = E.lienzo({ w: W, h: Hh, vista: [20, 170, 1100, 800], vistaMovil: [20, 200, 1040, 860] });
  E.titulo('El desayuno, [en uno].', 'Gira sus perillas reales para tostar el pan y prende la cafetera con su switch.');
  E.conSonido();
  S.cargando(true);

  S.img(D.base, null, { z: 1, alt: 'Horno 3 en 1 con cafetera y plancha' });
  const calor = S.img(D.calor.src, D.calor.caja, { z: 2, opacidad: 0 });
  const pan = S.img(D.pan.src, D.pan.caja, { z: 3, opacidad: 0 });
  const cafe = S.canvas(D.cafe.caja, { z: 4, res: 1 });
  const sw = S.img(D.switch.src, D.switch.caja, { z: 5, opacidad: 0 });
  const pw = S.img(D.power.src, D.power.caja, { z: 5, opacidad: 0 });
  const luzSw = S.luz(D.switch.centro[0], D.switch.centro[1], 30, { z: 6, color: '#FF3B2F', nucleo: .3 });
  const luzPw = S.luz(D.power.centro[0], D.power.centro[1], 26, { z: 6, color: '#FF3B2F', nucleo: .3 });
  const vapor = S.canvas([300, 80, 720, 380], { z: 7, res: 0.6 });
  const PT = D.perilla_temp, PI = D.perilla_tiempo;
  const capaTemp = S.img(PT.src, PT.caja, { z: 8, pivote: PT.centro });
  const capaTiempo = S.img(PI.src, PI.caja, { z: 8, pivote: PI.centro });
  let imgCafe = null;
  E.cargar([D.base, D.calor.src, D.pan.src, D.cafe.src]).then(r => { imgCafe = r[3]; S.cargando(false); });

  const ST = { tiempo: 0, total: 0, temp: 55, horno: 0, tostado: 0, cafe: 0, cafetera: false, listoHorno: false, corriendo: false, vioTemp: false };
  const ELI = [90, +(PT.rx / PT.ry).toFixed(4)];

  /* ---------- panel ---------- */
  E.pasos(['Gira el temporizador (perilla de abajo)', 'Ajusta el calor (perilla de arriba)', 'Prende la cafetera con el switch rojo']);
  E.paso(0);
  const lHorno = E.lectura({ etiqueta: 'Horno' }); lHorno.poner('Apagado');
  const lCalor = E.lectura({ etiqueta: 'Calor' }); lCalor.poner('Medio');
  const lCafe = E.lectura({ etiqueta: 'Cafetera' }); lCafe.poner('Apagada');
  [lHorno, lCalor, lCafe].forEach(l => { l.querySelector('.nhf-lectura__v').style.fontSize = 'clamp(26px,3vw,38px)'; });
  const barra = E.el('div', 'hn-barra'); barra.innerHTML = '<i></i>';
  barra.style.cssText = 'width:100%;height:3px;border-radius:3px;background:color-mix(in srgb,var(--ink) 12%,transparent);overflow:hidden';
  barra.firstChild.style.cssText = 'display:block;height:100%;width:0;background:var(--sage-ink)';
  E.ctrls.appendChild(barra);
  const bCafe = E.boton('Prender la cafetera', () => toggleCafe(), { icono: 'toca' });
  E.nota('En la demostración el tiempo pasa rápido.');

  /* ---------- perillas reales ---------- */
  const movil = () => window.innerWidth < 760;
  const pTiempo = E.perilla(capaTiempo, {
    centro: PI.centro, radio: PI.ry * 1.25, min: 0, max: 100, grados: [0, 270], valor: 0, elipse: ELI, etiqueta: 'Temporizador del horno',
    alCambiar(v) { if (!ST.corriendo) lHorno.poner(v > 2 ? 'Listo para tostar' : 'Apagado'); },
    alSoltar(v) { if (ST.corriendo) return; if (v > 6) arrancar(v); else pTiempo.poner(0, true, 300); },
    alTocar() { if (!ST.corriendo && pTiempo.valor() < 5) { E.animarP(500, k => pTiempo.poner(k * 70, true)).then(() => arrancar(70)); } }
  });
  pTiempo.el.classList.add('is-pista');
  const pTemp = E.perilla(capaTemp, {
    centro: PT.centro, radio: PT.ry * 1.25, min: 0, max: 100, grados: [0, 240], valor: 55, elipse: ELI, etiqueta: 'Temperatura del horno',
    alCambiar(v) { ST.temp = v; lCalor.poner(v < 34 ? 'Bajo' : v < 70 ? 'Medio' : 'Alto'); if (!ST.vioTemp && (ST.corriendo || ST.listoHorno)) { ST.vioTemp = true; guia(); } },
    alTocar() { const v0 = pTemp.valor(), nv = v0 >= 90 ? 30 : Math.min(100, v0 + 30); E.animarP(350, k => pTemp.poner(v0 + (nv - v0) * k, true)).then(() => pTemp.poner(nv)); }
  });
  const zonaSw = S.toque([D.switch.caja[0] - 14, D.switch.caja[1] - 14, D.switch.caja[2] + 28, D.switch.caja[3] + 28], { etiqueta: 'Switch de la cafetera', alTocar: () => toggleCafe() });

  function arrancar(v) {
    ST.total = 4 + v / 100 * 8; // segundos de demostración
    ST.tiempo = ST.total; ST.inicio = v; ST.corriendo = true; ST.listoHorno = false;
    pTiempo.el.classList.remove('is-pista');
    E.sonido.clic();
    lHorno.poner('Tostando');
    guia();
    if (movil()) S.camara(null, 900);
  }
  function toggleCafe() {
    ST.cafetera = !ST.cafetera; E.sonido.clic(); E.vibrar(10);
    sw.style.opacity = ST.cafetera ? 1 : 0; luzSw.set(ST.cafetera ? 0.55 : 0);
    bCafe.texto(ST.cafetera ? 'Apagar la cafetera' : 'Prender la cafetera');
    zonaSw.classList.remove('is-pista');
    lCafe.poner(ST.cafetera ? (ST.cafe >= 1 ? 'Café listo' : 'Preparando') : 'Apagada');
    guia();
  }
  function guia() {
    let p = 0, pista = 'Gira la perilla del temporizador';
    if (ST.corriendo || ST.listoHorno) { p = 1; pista = 'Sube o baja el calor con la otra perilla'; }
    if ((ST.corriendo || ST.listoHorno) && ST.vioTemp) { p = 2; pista = 'Prende la cafetera: el switch rojo'; if (!ST.cafetera) zonaSw.classList.add('is-pista'); }
    if (ST.cafetera) { p = 3; pista = ST.listoHorno && ST.cafe >= 1 ? '' : 'Mira: el pan se tuesta y el café llena la jarra'; }
    E.paso(p); S.pista(pista || null, p <= 1 ? 'gira' : 'toca');
    if (ST.listoHorno && ST.cafe >= 1) E.listo('Pan tostado, plancha caliente y café: el desayuno completo en un solo aparato.', reiniciar);
  }
  const vp = E.fx.particulas(vapor, { origen: D.vapor_plancha, tipo: 'vapor', vida: 2.6, tam: 34, vel: [6, -38], dispersion: 30, alfa: .16 });
  const vc = E.fx.particulas(vapor, { origen: D.vapor_cafe, tipo: 'vapor', vida: 2.4, tam: 28, vel: [-4, -34], dispersion: 20, alfa: .2 });
  let acum = 0;
  E.bucle((t, dt) => {
    // horno: el timer real corre y la perilla vuelve sola a cero; el calor sube y baja con inercia
    if (ST.corriendo) {
      ST.tiempo -= dt;
      pTiempo.poner(Math.max(0, ST.inicio * ST.tiempo / ST.total), true);
      if (ST.tiempo <= 0) {
        ST.corriendo = false; ST.listoHorno = true; pTiempo.poner(0, true);
        E.sonido.tono(2600, .5, .05); setTimeout(() => E.sonido.tono(2600, .4, .04), 260);
        lHorno.poner('¡Listo!'); guia();
      }
    }
    const meta = ST.corriendo ? 0.55 + 0.45 * ST.temp / 100 : 0;
    ST.horno += (meta - ST.horno) * Math.min(1, dt * (meta > ST.horno ? 1.4 : 0.7));
    calor.style.opacity = ST.horno.toFixed(3);
    pw.style.opacity = ST.corriendo ? 1 : 0; luzPw.set(ST.corriendo ? 0.6 : 0);
    if (ST.corriendo) ST.tostado = Math.min(1, ST.tostado + dt * (0.6 + 0.8 * ST.temp / 100) / Math.max(4, ST.total));
    pan.style.opacity = ST.tostado.toFixed(3);
    barra.firstChild.style.width = (ST.corriendo ? (1 - ST.tiempo / ST.total) * 100 : (ST.listoHorno ? 100 : 0)) + '%';
    // cafetera: el café real sube de abajo hacia arriba
    if (ST.cafetera && ST.cafe < 1) { ST.cafe = Math.min(1, ST.cafe + dt / 9); if (ST.cafe >= 1) { lCafe.poner('Café listo'); E.sonido.bip(1700); guia(); } }
    pintarCafe();
    // vapor suave: plancha caliente y cafetera trabajando
    acum += dt;
    vapor.limpiar();
    if (acum > 0.12) { if (ST.horno > 0.5) vp.emitir(1); if (ST.cafetera && ST.cafe < 1) vc.emitir(1); acum = 0; }
    vp.paso(dt); vc.paso(dt);
  });
  function pintarCafe() {
    cafe.limpiar();
    if (!imgCafe || ST.cafe <= 0) return;
    const c = D.cafe, s = c.sup, ctx = cafe.ctx;
    const k = 1 - Math.pow(1 - ST.cafe, 1.6);
    const dy = (c.fondo - (s.cy + s.ry)) * (1 - k); // la superficie sube desde el fondo hasta la de la foto
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(s.cx, s.cy + dy, s.rx, s.ry, s.ang * Math.PI / 180, 0, Math.PI * 2);
    ctx.rect(s.cx - s.rx - 30, s.cy + dy, s.rx * 2 + 60, 400);
    ctx.clip('nonzero');
    ctx.drawImage(imgCafe, c.caja[0], c.caja[1], c.caja[2], c.caja[3]);
    ctx.restore();
    if (k < 0.995) { // brillo de la superficie que sube
      ctx.save(); ctx.globalCompositeOperation = 'screen';
      ctx.strokeStyle = 'rgba(255,214,160,.32)'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.ellipse(s.cx, s.cy + dy, s.rx * (0.92 + 0.08 * k), s.ry, s.ang * Math.PI / 180, 0.15, Math.PI - 0.15); ctx.stroke(); ctx.restore();
    }
  }
  function reiniciar() {
    E.noListo();
    Object.assign(ST, { tiempo: 0, total: 0, temp: 55, horno: 0, tostado: 0, cafe: 0, cafetera: false, listoHorno: false, corriendo: false, vioTemp: false });
    pTiempo.poner(0, true); pTemp.poner(55, true); sw.style.opacity = 0; luzSw.set(0); bCafe.texto('Prender la cafetera');
    lHorno.poner('Apagado'); lCalor.poner('Medio'); lCafe.poner('Apagada'); pTiempo.el.classList.add('is-pista'); guia();
  }
  S.pista('Gira la perilla del temporizador', 'gira');
  E.alVer(() => { if (movil()) setTimeout(() => S.camara([300, 380, 560, 420], 1000), 600); }, 0.5);
});
